import React, { useEffect, useRef } from 'react'
import { ClientsWithRemainingMoneyVM } from '../../Structure/ViewModels/Admin/ClientsWithRemainingMoneyVM'
import { useVM } from '../../Structure/utilities/ViewModelStructure'
import { Container, Row } from 'react-bootstrap'
import Search from '../Utilities/Search'

const ClientsWithRemainingMoney = () => {
    const control = useVM<ClientsWithRemainingMoneyVM>(new ClientsWithRemainingMoneyVM())
    useEffect(()=>{control.getData()},[])

    useEffect(() => {
      const handleScrollPaths = () => {
          
          const elementPaths = scrollableRef.current;
          if (elementPaths) {
              const isNearBottom = elementPaths.scrollTop + elementPaths.clientHeight + 10 >= elementPaths.scrollHeight;
              if (isNearBottom) {
                  control.getMore();
              }
          }
      };
  
      const element = scrollableRef.current;
      if (element) {
          element.addEventListener('scroll', handleScrollPaths);
      }
  
      return () => {
          if (element) {
              element.removeEventListener('scroll', handleScrollPaths);
          }
      };
  }, [control.Data]);
  
  const scrollableRef = useRef<HTMLTableElement | null>(null);

  return (
    <Container>
      <div className='py-3'>
        <div className='d-flex py-2'>
          <div>
            <Search hasNoSelect onSearch={a=>{ control.Search = a; control.getData() }} />
          </div>

        </div>
        {
          control.Show(
            <div  ref={scrollableRef} className='overflow-x-auto' style={{ maxHeight:'70vh' }}>
            <table  ref={scrollableRef} className=' w-100 text-center' style={{minWidth:'500px'}}>
              <thead style={{ position:'sticky' }}>
                <tr className='txt-color-I bg-light-gray'>
                    <th>الاسم</th>
                    <th>المسوق</th>
                    <th>المسار</th>
                    <th>السعر</th>
                    <th>المدفوع</th>
                    <th>المتبقي</th>
                </tr>
              </thead>
              <tbody className='w-100'>
                {
                control.Data.map((item,index)=>(
                    <tr key={index} style={{background:index%2?'white':'rgba(200,200,200,0.2)'}}>
                        <td className='text-center'>{item.trainee_name}</td>
                        <td className='text-center'>{item.marketer_name}</td>
                        <td className='text-center'>{item.level_specialization_name}</td>
                        <td className='text-center'>{item.total_due}</td>
                        <td className='text-center'>{item.total_paid}</td>
                        <td className='text-center'>{Math.max(Number(item.total_due)-Number(item.total_paid) , 0)}</td>
                    </tr>
                ))
                }
              </tbody>

            </table>
          </div>
          )
        }
      </div>
    </Container>
  )
}

export default ClientsWithRemainingMoney
